import React from "react";
import { useTranslation } from "react-i18next";
import "./StudentListModalPeriodRibbon.scss";
import TestingWindow from "./TestingWindow";

interface AssessmentPeriodRibbonProps {
  remainingDays?: number;
  hasUpcoming?: boolean;
  type?: string;
  onAssignmentTypeChange?: (type: string) => void;
  assessmentRibbon?: boolean;
  studentListRibbon?: boolean;
  assignmentType?: string;
  hasActive?: boolean;
  daysUntilNextAssessmentWindowOpens?: number;
  noAssessmentWindow?: boolean;
  districtScreeningSetup?: boolean;
}

export const StudentListModalPeriodRibbon = ({
  remainingDays,
  hasUpcoming,
  onAssignmentTypeChange,
  assessmentRibbon,
  studentListRibbon,
  assignmentType,
  hasActive,
  daysUntilNextAssessmentWindowOpens,
  noAssessmentWindow,
  districtScreeningSetup
}: AssessmentPeriodRibbonProps) => {
  const { t } = useTranslation("assessment_modal");

  return (
    <div className={`period-ribbon ${(!hasActive && assessmentRibbon) ? '' : 'purple-alert'}`}>
      <div className="period-ribbon-inner">
            {/* {!hasActive && !hasUpcoming && <TestingWindow assessmentModal={true} />} */}
            {noAssessmentWindow && !districtScreeningSetup && (
              <div className="period-ribbon-time-alert">
                <div className="d-flex flex-column">
                  <span className="period-ribbon-time-alert-text d-flex align-items-center justify-content-center gap-2">
                    No Active Window
                  </span>
                </div>
              </div>
            )}
      {hasActive && assessmentRibbon && (
        <div className="period-ribbon-time-alert">
            <div className="d-flex flex-column">
              <span className="period-ribbon-time-alert-text d-flex align-items-center justify-content-center gap-2">
                <span className="period-ribbon-time-alert-text-days">{remainingDays}</span>
                {' '}
                {remainingDays && remainingDays > 1 ? t('assessment_window_days') : t('assessment_window_day')}
                {' '}
                {t('assessment_window_days_remaining')}
              </span>
          </div>
        </div>
      )}
      {hasActive && studentListRibbon && (
        <div className="period-ribbon-time-alert">
          <div className="d-flex flex-column">
            <span className="period-ribbon-time-alert-text d-flex align-items-center justify-content-center gap-2">
              <span className="period-ribbon-time-alert-text-days">{remainingDays}</span>
              {' '}
              {remainingDays && remainingDays > 1 ? t('assessment_window_days') : t('assessment_window_day')}
              {' '}
              {t('assessment_window_days_remaining')}
            </span>
          </div>
        </div>
      )}
      {!hasActive && hasUpcoming && studentListRibbon && (
        <div className="period-ribbon-time-alert">
          <div className="d-flex flex-column">
            <span className="period-ribbon-time-alert-text d-flex align-items-center justify-content-center gap-2">
              <span className="period-ribbon-time-alert-text-days">{daysUntilNextAssessmentWindowOpens}</span>
              {' '}
              {daysUntilNextAssessmentWindowOpens && daysUntilNextAssessmentWindowOpens > 1 ? 'days until your district assessment window opens' : 'day until your district assessment window opens'}
            </span>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};